module.exports = __webpack_public_path__ + "img/icon1.561b319b.png";